module.exports = "<block-ui>\n<app-alert></app-alert>\n<!-- <app-sidemenu></app-sidemenu> -->\n<app-pages-core></app-pages-core>\n</block-ui>"